import { cn } from "@/utils";
import { motion } from "motion/react";
import { useMemo } from "react";

const BAR_COUNT = 5;

interface AudioWaveformProps {
  audioLevel: number;
  isRecording: boolean;
  className?: string;
}

export const AudioWaveform: React.FC<AudioWaveformProps> = ({
  audioLevel,
  isRecording,
  className,
}) => {
  const barHeights = useMemo(
    () =>
      Array.from({ length: BAR_COUNT }, (_, i) =>
        Math.max(
          4,
          Math.round(audioLevel * 28 * (Math.sin(i * 0.8) * 0.3 + 0.7)),
        ),
      ),
    [audioLevel],
  );

  return (
    <div
      className={cn(
        "flex items-center gap-0.5 h-5 flex-1 justify-center min-w-0",
        className,
      )}
    >
      {barHeights.map((height, i) => (
        <motion.div
          key={i}
          className={cn(
            "w-1 rounded-full shrink-0",
            isRecording ? "bg-foreground/70" : "bg-muted-foreground/40",
          )}
          animate={{ height }}
          transition={{ duration: 0.08, ease: "easeOut" }}
        />
      ))}
    </div>
  );
};
